const I = -1, T = 100, o = 64, t = 84, E = 56, _ = 6;
export {
  o as LIST_ITEM_HEIGHT,
  t as LIST_ITEM_HEIGHT_WITH_DESCRIPTION,
  _ as MARGIN,
  I as NO_ACTIVE_OPTION,
  E as SEARCH_ITEM_HEIGHT,
  T as defaultScrollToElementTimeout
};
